type BuildAction = 'CREATE' | 'UPDATE' | 'DUPLICATE';

export const getIsMapTemplateChanged = ({
  action,
  originTemplateId,
  templateId,
}: {
  action: BuildAction;
  originTemplateId?: string;
  templateId?: string;
}) => {
  if (action !== 'UPDATE' || originTemplateId == null) {
    return false;
  }

  return originTemplateId !== templateId;
};
